import script from "./BusinessModuleEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessModuleEditor.vue?vue&type=script&setup=true&lang=js"

import "./BusinessModuleEditor.vue?vue&type=style&index=0&id=511ea2a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511ea2a5"]])

export default __exports__